@if (component) {
<href class="overflow-hidden"
      [link]="component.link || ''">
    <df-image-wrapper [class]="isRoundedImage ? '_border-radius overflow-hidden' : ''">
        <img [ratio]="component.ratio || 1"
             [dfImage]="component.image || ''">
    </df-image-wrapper>
</href>
}